import { apiFetch } from './apiClient';

export interface User {
  id: number;
  username: string;
  modules: string | null;
  sub_modules: string | null;
  admin_status: number;
  isAdmin: number;
  created_at: string;
  updated_at: string | null;
}

export interface UserPayload {
  username: string;
  isAdmin: boolean;
  permissions: string[];
  subModules: Record<string, unknown> | null;
  password?: string;
}

export const usersService = (token: string | null) => ({
  list: (page: number) =>
    apiFetch<{ users: User[]; total: number }>(token, `/api/users?page=${page}`),
  update: (id: number, payload: UserPayload) =>
    apiFetch(token, `/api/users/${id}`, { method: 'PUT', body: JSON.stringify(payload) }),
  create: (payload: UserPayload) =>
    apiFetch(token, '/api/users', { method: 'POST', body: JSON.stringify(payload) }),
  remove: (id: number) =>
    apiFetch(token, `/api/users/${id}`, { method: 'DELETE' }),
});
